
import Vue from 'vue';

export default Vue.extend({
    name: 'NotificationDialog',
    data() {
        return {
            loading: false,
            dialog: false,
            dialogType: '',
            dialogMessage: '',
            dialogTitle: '',
            hasCallback: false,
        };
    },
    methods: {
        async onYesClicked() {
            this.loading = true;
            await this.callback();
            this.loading = false;
            // this.dialog = false;
        },
        async callback() {
        },
    },
    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'notificationDialog/showMessage') {
                this.dialogType = state.notificationDialog.dialogType;
                this.dialogMessage = state.notificationDialog.dialogMessage;
                this.dialogTitle = state.notificationDialog.dialogTitle;
                this.dialog = state.notificationDialog.dialog;
                if (state.notificationDialog.onYesClicked) {
                    this.hasCallback = true;
                    this.callback = state.notificationDialog.onYesClicked;
                } else {
                    this.hasCallback = false;
                }
            }
        });
    },
});
